// Template: Add your feature flag here
// export const YOUR_FLAG_NAME_COOKIE_KEY = 'yourFlagName';
export const MATCHA_ACCOUNT = 'matcha-account';
export const DEDAUB_TOKEN_CHECK = 'dedaub-token-check';
/** Enforce the candidate CSP; otherwise collect reports without blocking resources. */
export const STRICT_CSP = 'strict-csp';
/** Show the Perps navigation and serve /perps; otherwise /perps is a 404. */
export const PERPS = 'matcha-perps';
/** Skip the perps geo restriction so trading can be tested from a blocked region. */
export const BYPASS_GEO = 'bypass-geo';
/** Use Matcha API holdings for the portfolio page; otherwise use Zerion. */
export const MATCHA_API_PORTFOLIO = 'matcha-api-portfolio';
/**
 * Stream the perps book and rich trades from the /api/perps/stream QuickNode relay; otherwise
 * Hyperliquid's public feed. Needs a Vercel runtime (`pnpm dev:vercel` locally) and mainnet.
 */
export const PERPS_STREAM_RELAY = 'perps-stream-relay';

export type FeatureFlagValues = Record<typeof DEDAUB_TOKEN_CHECK, boolean>;

export const DEFAULT_FEATURE_FLAGS: FeatureFlagValues = {
  [DEDAUB_TOKEN_CHECK]: false,
};

/// List of supported feature flags.
export const SUPPORTED_FEATURE_FLAGS: string[] = [
  // feature flags here
  // YOUR_FLAG_NAME_COOKIE_KEY,
  MATCHA_ACCOUNT,
  DEDAUB_TOKEN_CHECK,
  STRICT_CSP,
  PERPS,
  BYPASS_GEO,
  MATCHA_API_PORTFOLIO,
  PERPS_STREAM_RELAY,
];
